function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCross = function SvgIconCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 157.58 157.56",
    role: "img"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m150.06 100.47-19.91-19.91c-1-1-1-2.62 0-3.62l19.91-19.91c10-10.01 10.03-26.21.07-36.26L136.82 7.46c-10.04-9.97-26.26-9.94-36.26.07L80.65 27.44c-1 1-2.62 1-3.62 0L57.1 7.51c-10.04-10.02-26.29-10.02-36.33 0L7.51 20.76c-10.02 10.04-10.02 26.29 0 36.33l19.91 19.9c1 1 1 2.62 0 3.62L7.51 100.52c-9.99 10-9.99 26.2 0 36.2l13.31 13.31c10 9.99 26.2 9.99 36.2 0l19.91-19.9c1-1 2.62-1 3.62 0l19.91 19.91c10.04 10.02 26.29 10.02 36.33 0l13.26-13.26c10.02-10.04 10.02-26.29 0-36.33h.01Z",
    style: {
      fill: "#ede44f",
      strokeWidth: 0
    }
  }));
};
export default SvgIconCross;